import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './PlatformBadge.sass';

const cx = classnames.bind(styles);
const noop = () => null;

const PlatformBadge = ({ contentClass, renderIcon, label }) => (
  <div className={styles.platformBadge}>
    <div
      className={cx({
        platformBadgeContent: true,
        [contentClass]: true,
      })}
    >
      <div className={styles.platformBadgeIconContainer}>{renderIcon()}</div>
      <div className={styles.platformBadgeLabel}>{label}</div>
    </div>
  </div>
);

PlatformBadge.defaultProps = {
  contentClass: '',
  renderIcon: noop,
};

PlatformBadge.propTypes = {
  contentClass: PropTypes.string,
  renderIcon: PropTypes.func,
  label: PropTypes.string.isRequired,
};

export default PlatformBadge;
